<div class="site-branding" *ngIf="logo && logo.src">
    <div class="wrap">
        <app-svg [icon]="'logo_vertical'" [size]="sizeLogo"></app-svg>
        <div class="site-branding-text">
            <ng-content></ng-content>
        </div>
    </div>
</div>
